import { FlagsKey } from 'Types/common';

const flagsKeysValue = {
  [FlagsKey.EFIRMA_DG_ENABLED]: { enabled: false, value: FlagsKey.EFIRMA_DG_ENABLED },
  [FlagsKey.RESULT_MANDATORY_UPSELLING]: {
    enabled: false,
    value: FlagsKey.RESULT_MANDATORY_UPSELLING,
  },
  [FlagsKey.FLOW_ENABLED]: { enabled: false, value: FlagsKey.FLOW_ENABLED },
  [FlagsKey.FILE_NOW_PAY_LATER]: { enabled: true, value: FlagsKey.FILE_NOW_PAY_LATER },
  [FlagsKey.FILE_NOW_PAY_LATER_SETUP_CARD]: {
    enabled: false,
    value: FlagsKey.FILE_NOW_PAY_LATER_SETUP_CARD,
  },
  [FlagsKey.MGM_FLOW_ENABLED]: { enabled: true, value: FlagsKey.MGM_FLOW_ENABLED },
  [FlagsKey.PHONE_REQUEST_FLOW]: { enabled: false, value: FlagsKey.PHONE_REQUEST_FLOW },
  [FlagsKey.INSTANT_REFUND_ENABLED]: { enabled: true, value: FlagsKey.INSTANT_REFUND_ENABLED },
};

export const useFlags = (
  key: string
): { enabled: boolean; value: string | number | boolean | null | undefined } => {
  const { enabled, value } = flagsKeysValue[key];
  return { enabled, value };
};
